<template>
    <div class="p-3">
        <el-card header="Categorias">
            <PersonalTable :loading="loading" :height="450" :showRows="10" :cols="[
                {label: 'Cod', prop: 'id'},
                {label: 'Nome', prop: 'name'},
            ]" :data="data" >
                <el-table-column label="Criado por" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{data.row.user.name}}
                    </template>
                </el-table-column>
                <el-table-column label="Criado em" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{new Date(data.row.created_at).toLocaleString()}}
                    </template>
                </el-table-column>
                <el-table-column label="Acções" class-name="auto" :min-width="150">
                    <template #default="data">
                        <span class="p-2">
                            <el-button type="primary" tag="router-link" :to="'/categories/' + data.row.id" icon="View" title="Ver mais"></el-button>
                        </span>
                        <span class="p-2">
                            <el-button type="danger" icon="Delete" title="Apagar" @click="remove(data.row.id)"></el-button>
                        </span>
                    </template>
                </el-table-column>
            </PersonalTable>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElMessage, ElMessageBox } from 'element-plus';
import { useStore } from 'vuex';

    const loading = ref<boolean>(true)
    const data = ref<Array<any>>()

    const getCategories = async () => {
        const res = await Api.get('admin/categories')
        if (res.status == 200) {
            data.value = res.data.categories
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
    }
    const remove = async (id: number) => {
        ElMessageBox.confirm("Eliminar?").then(async (y) => {
            loading.value = true
            const res = await Api.delete(`admin/categories/${id}`)
            if (res.status >= 200 && res.status < 300) {
                await getCategories()
                ElMessageBox.alert("Eliminado", {type: 'success'})
                loading.value = false
            } else {
                ElMessageBox.alert('Ocorreu um erro ao buscar os dados').finally(() => {
                    loading.value = false
                })
            }
        }).catch(() => {
            //
            loading.value = false
        })
    }
    onBeforeMount(async () => {
        await getCategories()
        loading.value = false
    })

    const store = useStore()
    store.watch((state, getter) => getter.openModal, async (val, oldVal) => {
        if (oldVal == 0) {
            await getCategories()
        }
    })
</script>

<style lang="scss">
    .auto {
        min-width: 100px;
        width: auto !important;
        &>* {
            min-width: 100px;
            width: auto !important;
        }
    }
</style>
